<template>
  <div>
    <van-nav-bar
      title="发现牛股"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/')"
    />
    <iframe
      id="external-frame"
      scrolling="no"
      marginheight="0"
      marginwidth="0"
      frameborder="0"
      width="100%"
      :height="heigh"
      :src="found_winner_url"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "FoundWinners",
  data() {
    return {
      heigh: window.innerHeight - 100,
      found_winner_url: "",
    };
  },
  methods: {
    getUrl() {
      let that = this;
      that
        .$http({
          url: "/", //请求地址
          method: "post",
          data: {
            nozzle: "recommend_stock",
          },
        })

        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.found_winner_url = data;
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
  },
  mounted: function () {
    let that = this;
    that.getUrl();
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/FoundWinners.vue